// TODO: add preloader and handler for multiple images
import {useRef, useState, useEffect, useCallback, useMemo} from 'react'
// import {isEqual} from 'lodash'

import Grid from '@mui/material/Grid';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

import {getFileMeta, getFileAmount} from '../../../Helpers/forms';

import {useToasterStore} from '../../../Stores/toster';
import {useFormStore} from '../../../Stores/form';

import ContentImage from '../../../Modules/Content/Widgets/ContentImage';
import Preloader from '../../../Components/Preloaders/Preloader';

import './index.scss';

export default function Gallery(props) {
    const {content, disabled, field, hideErrors, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    
    const showErrorText = formVisibleErrors[field.id];

    const inputRef = useRef(null);
    let [textValue, setTextValue] = useState('')
    const [ammount, setAmmount] = useState(0);
    // const [sizeInfo, setSizeInfo] = useState(null);
    const [value, setValue] = useState(content[field.id])
    const [placeholder] = useState(field.placeholder ? field.placeholder + (field.required ? ' *' : '') : undefined)
    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])
    const [actionClassName, setActionClassName] = useState(showErrorText ? 'action error' : 'action')

    const [showSizeDetails, setShowSizeDetails] = useState(false)

    const textFieldClassName = useMemo(() => {
        let result = "filesList";
        result += isDisabled ? '' : 'emulateEnabled';
        result += (!hideErrors && showErrorText) ? ' error' : ''
        return result
    }, [hideErrors, showErrorText, isDisabled]);

    const {showError} = useToasterStore();

    useEffect(() => {
        if (content?.[field.id]) {
            let newValue = {}
            Object.keys(content[field.id]).map(i => {
                const meta = getFileMeta(content[field.id][i]);
                if (!meta.removed) {
                    newValue[i] = content[field.id][i]
                }
            })
            // TODO: compare files
            // if (!isEqual(value, newValue)) {
                setValue(newValue);

                const count = getFileAmount(content[field.id]);
                setAmmount(count);
                updateTextValue(count)
            // }
        }
        else {
            setValue(undefined);
            setAmmount(0);
            updateTextValue(0);
        }
    }, [content[field.id]])

    // useEffect(() => {
    //     if (field?.options?.size) {
    //         setSizeInfo(`Рекомендовані розміри - ${field?.options?.size.width} x ${field?.options?.size.height}`)
    //     }

    //     // setTextFieldClassName(getTextFieldClassName());
    // }, [])

    useEffect(() => {
        // setTextFieldClassName(getTextFieldClassName());
        setActionClassName(showErrorText ? 'action error' : 'action')
    }, [showErrorText])

    const onButtonClick = (e) => {
        inputRef.current.click()
    }

    const updateTextValue = (count) => {
        count > 0 ? setTextValue(`Додано ${count} файлів`) : setTextValue('')
    }

    const onFileChange = e => {
        const a = ammount + e.target.files.length;
        if (field?.options?.max && field?.options?.max < a) {
            showError({snackbarMessage: `Ви можете прикріпити не більше ${field?.options?.max} файлів`});
            return;
        }

        setAmmount(a);
        onChange(e);
        inputRef.current.value = null;
    }

    const onFileBlur = e => {
        if (onBlur) onBlur(e)
    }

    const onRemoveHandler = (name) => {
        inputRef.current.value = null;
        onChange({target: {files: [new File([''], name)]}})
    }

    let sizeHintStyle;
    const maxSize = 58;
    if (field?.options?.size?.width && field?.options?.size?.height) {
        if (field.options.size.width < field.options.size.height) sizeHintStyle = {height: maxSize + "px", width: parseInt(field.options.size.width / (field.options.size.height / maxSize)) + "px"}
        else sizeHintStyle = {width: maxSize + "px", height: parseInt(field.options.size.height / (field.options.size.width / maxSize)) + "px"}
    }
    
    const imgHor = field?.options?.size?.width > field?.options?.size?.height
    const imgVert = field?.options?.size?.width < field?.options?.size?.height
    const imgQ = field?.options?.size?.width == field?.options?.size?.height

    return <div className='GalleryUploadField'>
        <div className='fileUploadButton'>
            <div className='details'>
                <input
                    disabled={isDisabled}
                    multiple
                    className='originalControl'
                    accept="image/*"
                    type="file"
                    ref={inputRef}
                    onChange={onFileChange}
                    onBlur={onFileBlur}
                />

                <TextField
                    disabled
                    fullWidth
                    className={textFieldClassName ? `TextField ${textFieldClassName}` : 'TextField'}
                    variant="outlined"
                    label={placeholder}
                    value={textValue}
                    error={Boolean(!hideErrors && showErrorText)}
                    helperText={!hideErrors && showErrorText}
                />

                <Button
                    className={actionClassName}
                    variant="contained"
                    component="label"
                    tabIndex={-1}
                    onClick={onButtonClick}
                >
                    <AddIcon />
                </Button>
            </div>

            {!showErrorText && (sizeHintStyle || field?.options?.max || field?.description) && <div className='fieldNotes'>
                {field?.options?.max && <p>* Прикріпити можливо не більше {field.options.max} файлів</p>}
                {field?.description && <p>* {field.description}</p>}

                {sizeHintStyle && <p>* {imgHor ? "Горизонтальна картинка" : imgVert ? "Вертикальна картинка" : imgQ ? "Квадратна картинка" : ""}, рекомендовані розміри - {field?.options?.size.width} x {field?.options?.size.height}. <span className='pseudoLink' onClick={() => setShowSizeDetails(!showSizeDetails)}>Детальніше</span></p>}
                {/* <InfoOutlinedIcon onClick={() => setShowSizeDetails(!showSizeDetails)}/> */}
                {sizeHintStyle && <Slide in={showSizeDetails} mountOnEnter unmountOnExit>
                    <div className='sizeHintWrap'>
                        <div className='sizeHint'>
                            <div className='sizeHintExample' style={sizeHintStyle}></div>
                        </div>
                        <div>
                            {/* {parseInt(field.options.size.width/field.options.size.height)} */}
                            {imgHor && <div className='type'>Горизонтальна картинка</div>}
                            {/* {parseInt(field.options.size.width/field.options.size.height)} */}
                            {imgVert && <div className='type'>Вертикальна картинка</div>}
                            {imgQ && <div className='type'>Квадратна картинка</div>}
                            <div>Картинка буде автоматично масштабована під вказаний розмір. Якщо пропорції будуть не відповідні, частина картинки буде обрізана</div>
                        </div>
                    </div>
                </Slide>}
            </div>}
        </div>

        <GalleryPhotos field={field} value={value} onRemoveHandler={onRemoveHandler} />
    </div>
}

export function GalleryPhotos(props) {
    const {value, field, zoom, displayPreloader, onRemoveHandler} = props;

    const fileMeta = useCallback((file) => {
        return getFileMeta(file);
    }, [value])

    const xsSize = useMemo(() => {
        if (field?.options?.max > 1) return 6;
        return 12;
    }, [field])

    const mdSize = useMemo(() => {
        if (field?.options?.max === 2) return 6;
        if (field?.options?.max > 1) return 4;
        return 3;
    }, [field])

    if (!value || Object.keys(value).length === 0) return <></>
    
    return <Grid container spacing={2} className='GalleryPhotos UploadImageFormPhotos'>
        {Object.keys(value)
            .map((key) =>
                <Grid item xs={xsSize} md={mdSize} key={fileMeta(value[key]).name}>
                    <div className="photo">
                        <span className='imgWrap'>
                            {onRemoveHandler && <span className='close' onClick={() => onRemoveHandler(fileMeta(value[key]).name)}>
                                <ClearIcon />
                            </span>}

                            {displayPreloader && <Preloader />}

                            {fileMeta(value[key]).img.indexOf('http') !== 0 && <ContentImage zoom={zoom} image={fileMeta(value[key]).img} />}
                            {fileMeta(value[key]).img.indexOf('http') === 0 && <img loading="lazy" src={fileMeta(value[key]).img} />}
                        </span>
                        <span className='name'>
                            {fileMeta(value[key]).name}
                        </span>
                    </div>
                </Grid>
            )}
    </Grid>
}
